import {locationManager} from "@/assets/plugins/mps-common/location/location-manager";

const install = (Vue, options) => {
    Vue.prototype.$locationManager = locationManager;
};

export default {install}
